export default {
  primary: "#3B7AAD",
  // This color is generated from antd. See the colorPalette function in ant-design's repo.
  // Do update this color if the primary color above is updated
  hover: "#5D93BA",
};
